/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from "react";

import Footer from "../../components/Footer";
import Sidebar from "../../components/Sidebar";
import {
	Apresentation,
	ContentMain,
	DefaultButton,
	Error,
	MyTable,
	MyTableBody,
	MyTableHead,
	MyTableTR,
	Page,
	ScreenView,
	SubPageMain,
} from "../../style/default";
import { ModalContext } from "../../context/modal";
import { Skeleton } from "../../components/Skeleton/table";
import { MyHorizontalScrollView } from "./style";
import { toast } from "react-toastify";
import { authApi } from "../../services/api";
import { TOASTIFY_OPTIONS } from "../../style/global";
import MyTooltip from "../../components/Tooltip";
import { BiMessageSquareEdit } from "react-icons/bi";
import { ModalSectorEdit } from "./modal-edit";
import Select from "react-select";
import { customStyles } from "../../style/selectStyles";
import { SectorContext } from "../../context/sectorFilter";
function Sector() {
	const { open, handleOpenModal } = useContext(ModalContext);
	const [tableData, setTableData] = useState();
	const [selectAccountFilterData, setSelectAccountFilterData] = useState([{}]);
	const [selectedAccountFilterData, setSelectedAccountFilterData] = useState([
		{},
	]);
	const [isLoading, setIsLoading] = useState(false);
	const [modalData, setModalData] = useState({});
	const [modalSectorEdit, setModalSectorEdit] = useState(false);
	const { client } = useContext(SectorContext);
	const [clientFiltered, setClientFiltered] = useState("");
	const handleModalEdit = () => {
		setModalSectorEdit(true);
		handleOpenModal();
	};

	const populateTable = async (company = "") => {
		try {
			setIsLoading(true);
			const { data } = await authApi.post("/sector/list", {
				accountId: company,
			});
			setIsLoading(false);
			setTableData(data);
		} catch (error) {
			setIsLoading(false);
			toast.error("Não foi possivel encontrar os setores", TOASTIFY_OPTIONS);
		}
	};

	const populateSelect = async () => {
		try {
			const { data } = await authApi.get("/account/all/select");
			const seriData = [];
			data.forEach((item) => {
				seriData.push({ label: item.name, value: item._id });
			});
			setSelectAccountFilterData(seriData);
		} catch (error) {
			toast.error(
				"Não foi possivel encontrar os dados para filtro",
				TOASTIFY_OPTIONS
			);
		}
	};
	useEffect(() => {
		populateSelect();
		setClientFiltered(client?.label ? client?.label : "");
		setSelectedAccountFilterData(client ? client : undefined);
		populateTable(client?.value ? client?.value : "");
	}, []);

	return (
		<Page>
			{/* Handle modals below */}
			{open && modalSectorEdit && (
				<ModalSectorEdit
					open={open}
					data={modalData}
					populateTable={populateTable}
					clientName={[setClientFiltered, setSelectedAccountFilterData]}
				/>
			)}
			<Sidebar activeMenu="sectors" />
			<ScreenView>
				<ContentMain>
					<SubPageMain>
						<Apresentation>
							<span>
								Setores {clientFiltered.length ? `(${clientFiltered})` : ""}
							</span>
						</Apresentation>
						{isLoading ? (
							<Skeleton
								data={[
									"Cliente",
									"Setor",
									"Qtd de números",
									"Qtd de Atendentes",
									"Vazão diária atual",
									"Vazão diária esperada",
									"Ações",
								]}
							/>
						) : (
							<>
								<MyHorizontalScrollView>
									<div>
										<Select
											styles={customStyles}
											placeholder={"Filtrar por cliente"}
											options={[
												{ label: "Todos", value: "" },
												...selectAccountFilterData,
											]}
											onChange={(e) => {
												if (e.label !== "Todos") {
													setClientFiltered(e.label);
												} else {
													setClientFiltered("");
												}
												setSelectedAccountFilterData(e);
												populateTable(e.value);
											}}
											value={selectedAccountFilterData}
											noOptionsMessage={"Nenhum dado encontrado!"}
										/>
									</div>
								</MyHorizontalScrollView>

								{tableData && tableData.length ? (
									<>
										<MyTable responsive>
											<MyTableHead>
												<MyTableTR>
													<th>Cliente</th>
													<th>Setor</th>
													<th>Qtd de números</th>
													<th>Qtd de Atendentes</th>
													<th>Vazão diária atual</th>
													<th>Vazão diária esperada</th>
													<th>Ações</th>
												</MyTableTR>
											</MyTableHead>
											<MyTableBody>
												{tableData?.map((item) => (
													<MyTableTR key={item._id}>
														<td>{item.accountName ? item.accountName : "-"}</td>
														<td>{item.name ? item.name : "-"}</td>
														<td>
															{item.activeNumbers ? item.activeNumbers : "-"}
														</td>
														<td>
															{item.totalOperators ? item.totalOperators : "-"}
														</td>
														<td>{item.flowrate ? item.flowrate : "-"}</td>
														<td>
															{item.expectedFlowrate
																? item.expectedFlowrate
																: "-"}
														</td>
														<td>
															{" "}
															<MyTooltip label={`Editar: ${item.name}`}>
																<DefaultButton
																	onClick={() => {
																		handleModalEdit();
																		setModalData(item);
																	}}
																>
																	<BiMessageSquareEdit size={20} />
																</DefaultButton>
															</MyTooltip>
														</td>
													</MyTableTR>
												))}
											</MyTableBody>
										</MyTable>
									</>
								) : (
									<Error>Nenhum dado encontrado</Error>
								)}
							</>
						)}
					</SubPageMain>
				</ContentMain>
				<Footer />
			</ScreenView>
		</Page>
	);
}

export default Sector;
